// src/components/kidsa/KidsaVideo.tsx
import React, { useEffect, useState } from 'react';

interface KidsaVideoProps {
  backgroundImage: string;
  videoUrl: string;
}

const KidsaVideo: React.FC<KidsaVideoProps> = ({
  backgroundImage,
  videoUrl
}) => {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    // Inicializar magnific popup cuando esté disponible
    const initMagnificPopup = () => {
      if ((window as any).jQuery && (window as any).jQuery.fn.magnificPopup) {
        (window as any).jQuery('.video-popup').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });
      } else {
        // Reintentar si los scripts no están cargados todavía
        setTimeout(initMagnificPopup, 500);
      }
    };

    initMagnificPopup();

    // Cleanup
    return () => {
      if (showVideo) {
        setShowVideo(false);
      }
    };
  }, [showVideo]);

  return (
    <section className="cta-video-section bg-cover" style={{ backgroundImage: `url('${backgroundImage}')` }}>
      <div className="video-shape">
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
      <div className="container">
        <div className="cta-video-items">
          <div className="video-box">
            <a 
              href={videoUrl} 
              className="video-btn ripple video-popup"
              onClick={(e) => {
                // Si jQuery y magnificPopup no están disponibles, maneja el clic manualmente
                if ((window as any).jQuery && (window as any).jQuery.fn.magnificPopup) {
                  e.preventDefault();
                  window.open(videoUrl, '_blank');
                }
              }}
            >
              <i className="fa-solid fa-play"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaVideo;
